import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { Button } from "react-bootstrap";

const AllSupervisorList = ({
  getSupervisorListData,
  supervisorListData,
}) => {
  const headers = [
    "Name",
    "User Id",
    "Phone Number",
    "Is Primary Role",
    "Salary",
    "Blocking Amount",
    "Full Day Min. Hour",
    "Half Day Min. Hour",
    "Days Off",
    "Action",
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    (async () => {
        setIsLoading(true)
        setIsRoleId(window.localStorage.getItem("fusion-role"))
        await getSupervisorListData(null, 1)
        setIsLoading(false)
    })();
}, [])

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

const onPageChange = async (val) => {
    setIsLoading(true);
    await getSupervisorListData(null, val.selected + 1);
    setIsLoading(false);
};


const applyFilter = async (filterData) => {
    localStorage.setItem("all_valet_list_filter", JSON.stringify(filterData));
    setListData([])
    setIsLoading(true);
    setFilterData(filterData);
    await getSupervisorListData(filterData, 1);
    setIsLoading(false);
    filterToggle();
};

const DAYS_MAP = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
};

const mapDays = (daysOff) => {
  if (!daysOff) return '';
  return daysOff
    .toString()
    .split('')
    .map(day => DAYS_MAP[day] || '')
    .filter(day => day !== '')
    .join(', ');
};

useEffect(() => {
  const tableData = [
    "name",
    "user_id",
    "phone_number",
    "is_primary_role",
    "salary",
    "blocking_amount",
    "full_day_min_hour",
    "half_day_min_hour",
    "days_off"
  ];

  if (supervisorListData && supervisorListData.resultSets) {
    const data = supervisorListData.resultSets.map((element) =>
      Object.assign(
        {},
        ...tableData.map((key) => ({
          [key]: key === 'days_off' ? mapDays(element[key]) : key === 'is_primary_role' ? element['is_primary_role'] === true ? "True" : "False" : element[key]
        })),
        {
          Action: parseInt(isRoleId) === 26 ? [
            {
              name: "Update Details",
              link: `/dashboard/update-supervisor-data/${element.user_id}`
            },
          ] : parseInt(isRoleId) === 47 ? [{
            name: "Update Salary",
            link: `/dashboard/supervisor-salary-promotion/${element.user_id}`
          }] : [{}],
        }
      )
    );

    if (data.length > 0) {
      setListData(data);
    } else {
      setListData([]);
    }

    setPageCount(
      Math.ceil(supervisorListData.total / supervisorListData.per_page)
    );
  }
}, [supervisorListData]);


  // useEffect(() => {

  //   const tableData = [
  //     "name",
  //     "user_id",
  //     "phone_number",
  //     "is_primary_role",
  //     "salary",
  //     "blocking_amount",
  //     "full_day_min_hour",
  //     "half_day_min_hour",
  //     "days_off"
  //   ];
  //   if (supervisorListData && supervisorListData.resultSets) {
  //     const data = supervisorListData.resultSets.map((element) =>
  //       Object.assign(
  //         {},
  //         ...tableData.map((key) => ({ [key]: element[key] })),
  //         {
  //           Action: [
  //             {
  //               name: "Update Details",
  //               link: `/dashboard/update-supervisor-data/${element.user_id}`
  //             }
  //           ],
  //         }
  //       )
  //     );

  //     if (data.length > 0) {
  //       setListData(data);
  //     } else {
  //       setListData([]);
  //     }

  //     setPageCount(
  //       Math.ceil(supervisorListData.total / supervisorListData.per_page)
  //     );
  //   }
  // }, [supervisorListData]);

  return (
    <Layout
      title={'All Supervisor List'}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={supervisorListData?.from}
        onPageChange={onPageChange}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        allValetListFilter
      />
    </Layout>
  );
};

export default AllSupervisorList;
